module.exports = __webpack_public_path__ + "img/Annotated_Drakes_Lair_Map.8585fc9d.png";